var Check_Header = function () {
  var header = document.querySelector('header');
  if (header) {
    this.mobile = header.getAttribute('data-mobile');
  } else {
    this.mobile = '';
  }
  const isHover = () => {      
    return (window.matchMedia('(hover: hover) and (pointer: fine)').matches || (navigator.maxTouchPoints < 1));
  };
  if(isHover()) {
    body.classList.add('isDesktop');
    body.classList.remove('isMobile');
    theme.isMobile = false;
    theme.mobile = false;      
    if(this.mobile == 'mobile' || Layout.isBreakpoint('S')) {
      body.classList.add('isMobile');
      body.classList.remove('isDesktop');
      theme.mobile = true;
    }     
  } else {
    body.classList.add('isMobile', 'isTrueMobile');
    body.classList.remove('isDesktop');
    theme.isMobile = true; 
  };   
  document.documentElement.className=document.documentElement.className.replace(/\bno-js\b/,'js');
  if(window.Shopify&&window.Shopify.designMode)document.documentElement.className+=' in-theme-editor';
};
Check = (function() {
  function Check(section) {
    Check_Header();
  };
  return Check;
})();